// extracted by mini-css-extract-plugin
export default {"green":"#73c06b","grey100":"#f5f5f5","iconGrid":"IconSection_iconGrid__7c-wW","iconImg":"IconSection_iconImg__qbdat","iconLabel":"IconSection_iconLabel__UIVsQ"};